import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMutation, useQuery } from "react-apollo";
import { Layout, Button } from "@shopify/polaris";
import config from "configuration";

import { baseHelper, errorHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { Banner } from "lib/components";
// import config from "configuration";

import { FETCH_PLANS } from "app/plans/apollo/queries";
import { CREATE_PLAN, UPDATE_PLAN_DETAILS } from "app/plans/apollo/mutations";

import { Skeleton, PlanCard } from "./components";

// NOTE: To the future
// if there are two many differences between select & update plan then create separate file
const Plan = (props) => {
  const { banner, currentPlan, error, onFreeSubmit = () => {}, onSubmit = () => {}, submitLoading, setBanner } = props;
  const { cms, currentUser, history, isLoading } = useContext(PrivateContext);

  const isIframe = baseHelper.isIframe();

  const { gql } = constant;
  const {
    customer = "",
    plan: shopifyPlanCode = "",
    charge_id: shopifyChargeId = "",
    sub = "",
  } = baseHelper.queryParamsFromLocation(history);

  let isChargebee = !!customer; // May add additional setting to check if chargebee
  let planCode = shopifyPlanCode;
  let chargeId = isChargebee ? sub : shopifyChargeId;

  const isUpdate = !!(currentUser && currentUser.plan && currentUser.plan.code) || false;

  const { plan: userPlan = {} } = currentUser || {};
  const { isChargebee: isChargebeeValue = false, chargeId: chargbeeId, code } = userPlan || {};
  if (isChargebeeValue) {
    isChargebee = isChargebeeValue;
  }

  if (code) {
    planCode = code;
  }

  if (chargbeeId) {
    chargeId = chargbeeId;
  }

  const [activePlan, setActivePlan] = useState("");
  const { data: planData, error: planError, loading: planLoading } = useQuery(FETCH_PLANS);
  const [createPlan, { loading: createPlanLoading }] = useMutation(CREATE_PLAN);
  const [updatePlan, { loading: updatePlanLoading }] = useMutation(UPDATE_PLAN_DETAILS);

  useEffect(() => {
    if (currentPlan) {
      setActivePlan(currentPlan);
    }
  }, [currentPlan]);

  const thenBlock = (res) => {
    const redirectURL = `${currentUser.controlPanelBaseUrl}/manage/app/${config.bigCommerceMarketcubeAppId}`;
    const gqlPlanKey = isUpdate ? gql.UPDATE_PLAN_DETAILS : gql.CREATE_PLAN;
    const responseData = baseHelper.getResponseData(res.data, gqlPlanKey);

    if (responseData) {
      const title = isUpdate ? cms("message.success.update") : cms("message.success.select");

      setBanner({
        isOpen: true,
        status: constant.SUCCESS,
        title,
      });
      setActivePlan(planCode);

      setTimeout(() => {
        if (!isIframe && currentUser.controlPanelBaseUrl) {
          window.top.location = redirectURL;
        } else {
          return history.push("/");
        }
      }, 1500);
    } else {
      const responseError = baseHelper.getResponseError(res.data, gqlPlanKey);
      setBanner({
        isOpen: true,
        status: constant.CRITICAL,
        title: responseError,
      });
    }
  };

  const catchBlock = (exception) => {
    setBanner({
      isOpen: true,
      status: constant.CRITICAL,
      title: exception.message,
    });
  };

  useEffect(() => {
    if (isChargebee && !isUpdate) {
      const planInput = {
        code: planCode,
        chargeId,
      };

      if (customer && !isUpdate) {
        planInput.customer = customer;
      }

      if (isUpdate && isChargebee) {
        planInput.code = planCode;
      }

      createPlan({
        variables: {
          input: planInput,
        },
      })
        .then((res) => {
          thenBlock(res);
        })
        .catch((exception) => {
          catchBlock(exception);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chargeId, createPlan, customer, isLoading, planCode]);

  if (planLoading || isLoading || createPlanLoading || updatePlanLoading) {
    return <Skeleton />;
  }

  if (error) {
    return (
      <Layout.Section>
        <Banner isOpen status={constant.CRITICAL} title={error} />
      </Layout.Section>
    );
  }

  if (planError) {
    const parsedError = errorHelper.parse(planError);
    return (
      <Layout.Section>
        <Banner isOpen status={constant.CRITICAL} title={parsedError} />
      </Layout.Section>
    );
  }

  const plans = baseHelper.getResponseData(planData, "getPlans") || [];
  if (plans.length === 0) {
    return (
      <Layout.Section>
        <Banner isOpen status={constant.CRITICAL} title={cms("message.error.planNotFound")} />
      </Layout.Section>
    );
  }

  const getFreePlan = () => {
    const freePlan = plans.find((plan) => plan.code === constant.FREE);
    return freePlan;
  };

  const selectFreePlan = () => {
    onFreeSubmit();
  };

  const renderFreePlan = (selectedPlan = "") => {
    const plan = getFreePlan();
    if (!plan || plan.isHidden || isUpdate) {
      return null;
    }

    return (
      <Layout.Section>
        <center>
          <br />
          <Button
            disabled={selectedPlan === plan.code}
            onClick={() => selectFreePlan()}
            loading={selectedPlan === plan.code}
            size="slim"
            outline
            monochrome
          >
            {cms("button.free")}
          </Button>
        </center>
      </Layout.Section>
    );
  };

  const chargeableSortedPlans = plans
    .filter((plan) => !plan.isHidden && !baseHelper.isFreePlan({ plan }) && plan.code !== "startup")
    .sort((first, second) => first.sortOrder - second.sortOrder);

  const startUpPlan = plans.find(plan => !plan.isHidden && plan.code === "startup");

  const getLayoutSections = () => {
    return chargeableSortedPlans.map((plan) => {
      const submitCallback = () => {
        onSubmit(plan);
      };
      return (
        <Layout.Section oneThird key={plan && plan.name}>
          <PlanCard
            plan={plan}
            callback={() => submitCallback(plan)}
            activePlan={activePlan}
            submitLoading={submitLoading}
          />
        </Layout.Section>
      );
    });
  };
  return (
    <>
      {banner.isOpen && (
        <Layout.Section>
          <Banner
            isOpen={banner.isOpen}
            status={banner.status}
            title={banner.title}
            onDismiss={() => setBanner({ isOpen: false, status: "", title: "" })}
          />
        </Layout.Section>
      )}
      <Layout.Section>
        {startUpPlan && (
          <Layout>
            <Layout.Section key={startUpPlan.name}>
              <PlanCard
                plan={startUpPlan}
                callback={() => onSubmit(startUpPlan)}
                activePlan={activePlan}
                submitLoading={submitLoading}
              />
            </Layout.Section>
            <Layout.Section />
          </Layout>
        )}
        <Layout>{getLayoutSections()}</Layout>
        <br />
        <Layout>{renderFreePlan(activePlan)}</Layout>
      </Layout.Section>
    </>
  );
};

Plan.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  currentPlan: PropTypes.string,
  error: PropTypes.string,
};

Plan.defaultProps = {
  currentPlan: "",
  error: "",
};

export default Plan;
